import React from "react";
import logo from "../assets/images/svg/head.svg";
import face from "../assets/images/svg/face.svg";
import insta from "../assets/images/svg/insta.svg";
import tweet from "../assets/images/svg/tweet.svg";
import pinterest from "../assets/images/svg/pinterst.svg";
import "../styles/footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <div className="content">
        <div className="first-row">
          <p className="heading-footer">#SmartTechSolutions</p>
          <div>
            <div className="contact-div">
              <p className="contact-txt">Contact</p>
            </div>
            <div className="contact">
              <p>Islamabad Pakistan</p>
              <p>+92336962425</p>
              <p>ik447626@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="middle-row">
          <div>
            {/* <img src={logo} style={{ width: "100%", height: 50 }} alt="logo" /> */}
          </div>
          <div style={{ marginTop: 30 }}>
            <p className="join-text">Join our mailing list for updates,</p>
            <p className="join-text">Get news & offer events</p>
          </div>
          <div className="join-div">
            <input type="email" placeholder="Email" className="email-input" />
            <input type="button" value="Subscribe" className="footer-submit" />
          </div>
        </div>
        <div className="last-row">
          <div className="social-icons">
            <img src={face} alt="facebook" />
            <img src={insta} alt="insta" />
            <img src={tweet} alt="tweet" />
            <img src={pinterest} alt="pinterst" />
          </div>
          <div className="working-div">
            <p className="contact-txt">working hours</p>
          </div>
          <div className="working-hours space-y-0.5">
            <p>
              Mon - Fri : <span>9.00am - 12.00am</span>
            </p>
            <p className="decoration-sky-500/30">
              Sat: <span>11.00am - 12.00pm</span>
            </p>
            <p>
              Sun: <span>11.00am - 6.00pm</span>
            </p>
          </div>
        </div>
      </div>
      <div className="bottom">
        <p>© Engr Imran - Solutions</p>
      </div>
    </div>
  );
}
